import { KeyClubProfile as KeyClubProfileType } from '@/lib/types/keyClubProfile';

/**
 * Retrieves the user's Key Club profile, using encrypted session storage to cache the result.
 * If the Key Club profile is not cached, it fetches it from the API.
 *
 * @param {string} keyclubNumber - The user's Key Club number.
 * @returns {Promise<KeyClubProfile | null>} The Key Club profile data.
 */
export async function getUserKeyClubProfile(
  keyclubNumber: string,
): Promise<KeyClubProfileType | null> {
  if (!keyclubNumber) {
    return null;
  }

  const response = await fetch(`/api/keyclub/member/${keyclubNumber}/`, {
    method: "GET",
    headers: {
      "Pragma": "no-cache",
      "Cache-Control": "no-cache, no-store, must-revalidate",
      "Expires": "0",
    },
    cache: "no-store", // Prevent Next.js from caching
  });

  if (response.status === 401 || response.status === 404 || !response.ok) {
    return null;
  }

  const text = await response.text();
  if (!text.trim()) {
    return null;
  }

  try {
    return JSON.parse(text) as KeyClubProfileType;
  } catch {
    return null;
  }
}
